import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Delete } from '../../HemeIconLibrary';
import Pharmacy from '../../assets/images/pharmacy.png';
import { QuantityButton } from '../../utils';
import DeleteButton from '../../utils/deleteButton';

const ShoppingTable = ({ data, changeQuantity, addToCart }) => {
  const [show, setShow] = useState(false);
  const customStyles = {
    style: {
      border: '1px solid #DEE2E6',
    },
    headCells: {
      style: {
        backgroundColor: '#F9F4FF',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '24px',
        borderLeft: '1px solid #DEE2E6',
        borderTop: '1px solid #DEE2E6',
      },
    },
    cells: {
      style: {
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px',
        color: '#595959',
        borderLeft: '1px solid #DEE2E6',
      },
    },
  };
  // useEffect(() => {
  //   if (show) {
  //     addToCart();
  //     setShow(false);
  //   }
  // }, [show]);

  return (
    <div className={data.length > 1 && 'border-r-[1px] border-b-[1px] border-solid border-[#DEE2E6]'}>
      <DataTable
        customStyles={customStyles}
        data={data}
        columns={[
          {
            style: {
              padding: '0 14px',
            },
            center: true,
            name: '',
            width: '50px',
            selector: (row, index) => <DeleteButton data={row} cta={addToCart} key={index} />,
          },
          {
            name: 'SKU',
            selector: (row) => (
              <div className="flex items-center gap-[10px]">
                <img src={Pharmacy} alt="Pharmacy" /> {row?.serialNumber}
              </div>
            ),
          },
          {
            name: 'Product(s)',
            selector: (row) => row?.name,
            wrap: true,
          },
          {
            name: 'Requested Quantity',
            selector: (row) => <QuantityButton changeQuantity={changeQuantity} border data={row} deleteIcon cta={addToCart} />,
          },
        ]}
      />
    </div>
  );
};

export default ShoppingTable;
